import { isFinite } from "lodash";
import { dateBasedYearHelper } from "./value-helpers";
import { numberFormatters } from "common";
import { getDateAndTimeString, getDateString, getFormattedDateAlignWithUserSettings, getTimestampFromDateString } from "common/date-utils";
import { NumberFormatKind } from "common/types";
import { RelativeValueOptions } from "store/widget-workshop/types";
const percentageFormatter = (params) => {
    if ((String(params.colDef?.relativeValueOption) === RelativeValueOptions.AgainstGrandTotal ||
        String(params.colDef?.relativeValueOption) === RelativeValueOptions.AgainstGroups) &&
        params.node?.group) {
        return "";
    }
    else if ((params.value || params.value === 0) && !isNaN(params.value)) {
        return numberFormatters(params.value, NumberFormatKind.percent, { minimumFractionDigits: 2 });
    }
    return params.value;
};
const multiplyFormatter = (params) => ((params.value || params.value === 0) && !isNaN(params.value)
    ? `${numberFormatters(params.value, NumberFormatKind.compact, { minimumFractionDigits: 2 })}x`
    : params.value);
const yearsFormatter = (params) => (params.value && !isNaN(params.value)
    ? `${numberFormatters(params.value, NumberFormatKind.compact)} year${params.value > 1 ? "s" : ""}`
    : params.value);
const moneyFormatter = (params) => {
    if (!params.value) {
        return params.value;
    }
    const { amount, currency } = params.value;
    return isFinite(amount) && currency !== null
        ? `${numberFormatters(amount, NumberFormatKind.currency, { compactDisplay: "short",
            currency,
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
            notation: "compact" })}`
        : "";
};
const areaFormatter = (params) => {
    if (!params.value) {
        return params.value;
    }
    const { area, unit } = params.value;
    return isFinite(area)
        ? `${numberFormatters(area, NumberFormatKind.default, { compactDisplay: "short",
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
            notation: "compact" })} ${unit}`
        : "";
};
const unitFormatter = (params) => {
    if (!params.value) {
        return params.value;
    }
    const { value, unit } = params.value;
    return isFinite(value)
        ? `${numberFormatters(value, NumberFormatKind.compact, { maximumFractionDigits: 2, minimumFractionDigits: 2 })} ${unit}`
        : "";
};
const dateFormatter = (params) => {
    const { value } = params;
    let date = value instanceof Date ? value : null;
    if (typeof value === "string") {
        const mlsec = getTimestampFromDateString(value);
        if (!isNaN(mlsec) && mlsec > 0) {
            date = new Date(mlsec);
        }
    }
    else if (value && typeof value === "object") {
        const { year, month, day } = value;
        if (year && month && day) {
            date = new Date(year, month - 1, day);
        }
    }
    return date ? getDateString(date) : "";
};
const dateTimeFormatter = (params) => {
    const { value } = params;
    return value ? getDateAndTimeString(value) : "";
};
const userSettingAlignedDateFormatter = (params) => {
    const { value } = params;
    return value ? getFormattedDateAlignWithUserSettings(value) : "";
};
const dateBasedYearFormatter = (params) => {
    const { value, context } = params;
    return dateBasedYearHelper(value, context);
};
const idToNameFormatter = (p) => {
    const fieldPath = p.context?.linksMapping?.find((m) => m.id === p.colDef.field)?.field;
    if (fieldPath) {
        let value = p.data?.[fieldPath] ?? "";
        if (p.node?.group && p.value && Array.isArray(p.node.allLeafChildren)) {
            const [child] = p.node.allLeafChildren;
            value = child?.data[fieldPath];
        }
        return value;
    }
    return p.value;
};
const textFormatter = (params) => (params.value ? String(params.value) : params.value);
export { percentageFormatter, multiplyFormatter, yearsFormatter, dateFormatter, dateTimeFormatter, dateBasedYearFormatter, moneyFormatter, idToNameFormatter, areaFormatter, unitFormatter, userSettingAlignedDateFormatter, textFormatter };
